import React, { FC } from "react";
import { Typography, TypographyProps } from "@mui/material";

const AppScreenTitle: FC<TypographyProps> = ({ children }) => {
  return (
    <Typography variant="h4" gutterBottom>
      {children}
    </Typography>
  );
};

export default AppScreenTitle;
